export class LeadDataModel {

    leadAddFormModel = {
        accountName: null,
        isIndividualAccount: '1',
        isCustomer: false,
        notes: null,
        isRfqAccount: false,
        accountDetails: {
            leadSourceId: null,
            assignedTo: null,
            industryId: null,
            accountStatusId: null,
            isWarm: true
        },
        contact: {
            contactTypeId: 1,
            firstName: null,
            middleName: null,
            lastName: null,
            email: null,
            primaryPhone: null,
            isInternationalPhone: false,
            primaryExt: null,
            contactNumberList: [],
            primaryCountryCode: null
        },
        address: {
            addressLine1: null,
            addressLine2: null,
            fullAddress: null,
            city: null,
            provinceId: null,
            zipCode: null,
            countryId: null,
            addressIndicator: '1',
            customeAddressTypeInfo: null,
            addressTypeId: 1
        },
    };

    leadEditFormModel = {
        leadId: null,
        accountName: null,
        isIndividualAccount: null,
        notes: null,
        isActive: null,
        accountDisplayId: null,
        isRfqAccount: false,
        accountDetails: {
            accountDetailsId: null,
            leadSourceId: null,
            assignedTo: null,
            assignedToId: null,
            industryId: null,
            accountStatusId: null,
            leadSourcePrimaryId: null,
            industryPrimaryId: null,
            isWarm: true
        },
        contact: {
            contact: null,
            accountId: null,
            contactId: null,
        },
        address: {
            address: null,
            accountId: null,
            addressId: null,
        },
    };

    statusUpdateModel = {
        accountId: null,
        isActive: null
    };

    bulkStatusUpdateModel = {
        isActive: null,
        accountId: []
    };

    leadDetailsModel = {
        accountName: null,
        industryName: null,
        lastActive: null,
        leadSourceName: null,
        createdBy: null,
        createdOn: null,
        accountType: null,
        stageStatus: null,
        activeStatus: null,
        assignedTo: null,
        accountDisplayId: null
    };

    summaryModel = {
        contactsCount: 0,
        addressesCount: 0,
        markupsCount: 0,
        quotesCount: 0,
        servicesCount: 0,
        popupsCount: 0,
        appointmentsCount: 0,
        documentsCount: 0,
        notesCount: 0,
        boxMapping: 0
    };

    accountDetails = {
        accountName: null,
        isIndividualAccount: null
    };

    getFilters(response?: any): object {
        return [
            { routerLink: 'all-leads', text: 'All Leads', count: response ? response.totalResults : 0 },
            { routerLink: 'added-in-last', text: 'Added in Last 7 days', count: 0 },
            // { routerLink: 'accessed-in-last', text: 'Accessed in Last 7 days', count: 0 },
            { routerLink: 'modified-in-last', text: 'Modified in Last 7 days', count: 0 },
            // { routerLink: 'inactive', text: 'Inactive for one year', count: 0 },
            { routerLink: 'cold-leads', text: 'Cold Leads', count: 0 },
            // { routerLink: 'disqualified-leads', text: 'Disqualified Leads ', count: 0 },
            // { routerLink: 'converted-leads', text: 'Converted Leads ', count: 0 },
            // { routerLink: 'leads-without-quote', text: 'Lead without quote', count: 0 },
            { routerLink: 'leads-with-quote', text: 'With quote', count: 0 },
        ];
    }

    getFiltersLinks() {
        return {
            All: { label: 'All', link: 'all-leads' },
            AddedInSevenDays: { label: 'Added In 7 Days', link: 'added-in-last' },
            ModifiedInSevenDays: { label: 'Modified In 7 Days', link: 'modified-in-last' },
            WithQuotes: { label: 'With Quotes', link: 'leads-with-quote' },
            IsCold: { label: 'Cold Leads', link: 'cold-leads' }
        };
    }
}
